import React from "react";
import styled from "styled-components";
import PropTypes from "prop-types";
import colors from "styles/colors";
import typography, { applyTypography } from "styles/typography";

const StyledText = styled.span`
  font-family: ${typography.fontFamily};
  font-size: ${({ size }) => size || typography.body.regular.fontSize};
  font-weight: ${({ weight }) => weight || typography.body.regular.fontWeight};
  color: ${({ color, gradient }) =>
    gradient ? "transparent" : color || colors.text.dark};

  ${({ typographyStyle }) =>
    applyTypography(typographyStyle || typography.body.regular)}

  ${({ gradient }) =>
    gradient &&
    `
    background: linear-gradient(90deg, ${gradient});
    -webkit-background-clip: text;
    background-clip: text;
    -webkit-text-fill-color: transparent;
  `}
`;

const Text = ({
  children,
  size,
  weight,
  color,
  gradient,
  className,
  typographyStyle,
  dangerouslySetInnerHTML,
  ...props
}) => {
  return (
    <StyledText
      typographyStyle={typographyStyle}
      size={size}
      weight={weight}
      color={color}
      gradient={gradient}
      className={className}
      dangerouslySetInnerHTML={dangerouslySetInnerHTML}
      {...props}
    >
      {children}
    </StyledText>
  );
};

Text.propTypes = {
  children: PropTypes.node.isRequired,
  size: PropTypes.string,
  weight: PropTypes.string,
  color: PropTypes.string,
  gradient: PropTypes.string, // Accepts a comma-separated gradient string from colors.gradients
  className: PropTypes.string,
};

export default Text;